import React, { useEffect } from 'react';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  Icon,
  Typography
} from '@material-ui/core';
import { useStyles } from './styles';
import { ChartHelpers } from './chart-helpers';
import TotalChart from './total-chart';
import { ChartLocation } from './types';
import { useNavigate, useParams } from 'react-router-dom';
import { Title } from '../../elements';

const Analytics: React.FC<any> = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const { locations } = useParams<{ locations: string }>();
  const locationsValue: { id: string; name: string }[] = JSON.parse(locations as string);

  const [selectedLocations, setSelectedLocations] = React.useState<ChartLocation[]>([]);

  useEffect(() => {
    setSelectedLocations(
      locationsValue.map((entry) => {
        return { id: entry.id, name: entry.name, isSelected: true };
      })
    );
  }, []);

  const toggleRoom = (name: string) => {
    setSelectedLocations(
      selectedLocations.map((room) => {
        if (room.name === name) {
          return { ...room, isSelected: !room.isSelected };
        }
        return room;
      })
    );
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <Title>Vitality Tracker data analytics</Title>
      </Grid>

      <Grid item md={3}>
        <Card variant="elevation" elevation={1} className={classes.legendContainer}>
          <CardContent className={classes.legendContainer}>
            <Grid container spacing={1}>
              <Grid item md={12} className={classes.popoverGridItem}>
                <FormLabel component="legend">Rooms (X axis):</FormLabel>
                <FormGroup>
                  {selectedLocations.map((location, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            checked={location.isSelected}
                            size="small"
                            onChange={() => toggleRoom(location.name)}
                            name={location.name}
                          />
                        }
                        label={<Typography>{location.name}</Typography>}
                      />
                    );
                  })}
                </FormGroup>
              </Grid>
            </Grid>

            <Grid item>
              <FormLabel component="legend">Area types:</FormLabel>

              {ChartHelpers.getActivitiesWithColors().map((activity, index) => {
                return (
                  <Typography variant="body1" key={index} style={{ color: activity.color }}>
                    {activity.key}
                  </Typography>
                );
              })}
            </Grid>

            <Grid item>
              <Button
                color="primary"
                fullWidth
                startIcon={<Icon>equalizer</Icon>}
                variant="contained"
                onClick={() => navigate('/analytics/detailed/' + locations)}
              >
                Detailed
              </Button>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item md={3}>
        <Card variant="elevation" elevation={1}>
          <CardContent>
            <TotalChart locations={selectedLocations} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item md={3}>
        <Card variant="elevation" elevation={1}>
          <CardContent>
            <TotalChart locations={selectedLocations} />
          </CardContent>
        </Card>
      </Grid>
      <Grid item md={3}>
        <Card variant="elevation" elevation={1}>
          <CardContent>
            <TotalChart locations={selectedLocations} />
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Analytics;
